enum EntityType {
  COMPANY = "Company",
  PERSON = "Person",
}

export default EntityType;
